<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyWork"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun"
          >查询</Button
        >
      </template></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="kaipiao">
        <Button @click="kaipiao(row)" v-if="row.ticketStatus == 0">开票</Button>
        <span v-else>已开票</span>
      </template>
      <template slot-scope="{ row, index }" slot="filesArr">
        <viewer v-if="row.filesArr">
          <img
            v-for="(x, index) in row.filesArr"
            :key="index"
            :src="axios.platConfig.fileUri + x"
            width="24"
            height="24"
            style="margin-right: 4px; cursor: pointer"
          />
        </viewer>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button
          size="small"
          :disabled="row.auditorTwo != null"
          @click="openShenhe(row, index)"
          >审核</Button
        >
        <Button size="small" @click="openUpdateStatus(row, index)">状态</Button>
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
var kehuitems = [];
export default {
  components: {},
  data() {
    return {
      columns: [
        {
          title: "订单号",
          key: "ono",
          width:150
        },
        {
          title: "状态",
          key: "status2",
        },
        {
          title: "客户名称",
          key: "customer",
        },
        /* {
          title: "费用项目",
          key: "costName",
        }, */
        {
          title: "币别",
          key: "currency",
        },
        {
          title: "类别",
          key: "voucherType2",
        },
        {
          title: "金额",
          key: "money",
        },
        {
          title: "到账日期",
          key: "accountDate2",
        },
        {
          title: "附件",
          key: "fileUrl",
          slot: "filesArr",
        },
        {
          title: "台账账号",
          key: "tallyAccount",
        },
        {
          title: "台账余额",
          key: "tallyAccountMoney",
        },
        {
          title: "操作员",
          key: "creator",
        },
        {
          title: "操作时间",
          key: "createTime2",
        },
        {
          title: "备注",
          key: "remark",
        },
      ],
      tableData: [],
      item: {
        tallyAccountId: 0,
        money: 0,
        ordersChargesId: 0,
        accountDate: "",
        fileUrl: "",
        voucherType: 0,
        keyWork: "",
      },
      forms: [],

      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        startTime: "",
        endTime: "",
        cid: "",
        ono: "",
        keyWork: "",
        voucherType: -1,
      },
      total: 0,

      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },
        {
          title: "客户",
          key: "cid",
          selectItems: kehuitems,
          type: "Select",
          selectType: "obj",
        },
        {
          title: "类型",
          key: "voucherType",
          selectItems: [
            { id: -1, name: "全部" },
            { id: 0, name: "收入" },
            { id: 1, name: "支出" },
          ],
          type: "Select",
          selectType: "obj",
        },
      ],
    };
  },
  //http://59.37.161.185:8090/#/locate?now=1
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-fms/tallyBook/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        var status = { 0: "正常", 1: "作废" };
        var voucherType = { 0: "收入", 1: "支出" };
        for (let i = 0; i < data.length; i++) {
          data[i].status2 = status[data[i].status];
          data[i].voucherType2 = voucherType[data[i].voucherType];
          data[i].accountDate2 = this.utils.time(data[i].accountDate, "yymmdd");
          data[i].createTime2 = this.utils.time(data[i].createTime);
          data[i].filesArr = this.utils.strToJson(data[i].fileUrl);
        }
        this.tableData = data;
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    kehuList() {
      kehuitems.splice(0, 1000);
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-base/customer/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          var obj = {
            id: data[i].id,
            name: data[i].name,
          };
          kehuitems.push(obj);
        }
      });
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 240,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
    //
    this.kehuList();
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwu/shouzhijilu.vue